import { Injectable } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { BuildingFormComponent } from 'src/app/geometrics-form/buildings/building-form/building-form.component';
import { Building } from 'src/app/geometrics-form/buildings/state/building.model';
import { GeometricFormType } from 'src/app/geometrics-form/state/geometric-form.type';
import { MapService } from 'src/app/shared/components/map/map.service';
import { FeatureDragingDropService } from '../actions/layer-actions/feature-draging-drop.service';
import { FeatureOpenService } from '../actions/layer-actions/feature-open.service';
import { FeatureSelectionService } from '../actions/layer-actions/feature-selection.service';
import { buildingToFeature, buildingVertexToFeature } from '../mappers/geojon-mapper';
import { Plotter } from './plotter';

@Injectable({
  providedIn: 'root'
})
export class BuildingPlotter extends Plotter<Building> {

  type: GeometricFormType = 'mitra-building';
  mapper = buildingToFeature;
  typeConn = this.type + '-conn';

  constructor(
    protected mapService: MapService,
    dragingDropService: FeatureDragingDropService,
    openService: FeatureOpenService,
    selectionService: FeatureSelectionService

  ) {
    super([selectionService, dragingDropService]);

    openService.active = true;
    const titleConfig = $localize`EDIT BUILDING`;

    mapService.map$.subscribe(m => {
      this.init(m);
      openService.listen(
        m,
        {
          title: titleConfig,
          layerName: this.type,
          componentType: BuildingFormComponent
        }
      );
    });
  }

  layer: mapboxgl.Layer = {
    id: this.type,
    type: 'line',
    source: this.type,
    paint: {
      'line-color':
        [
          'match',
          ['get', 'map_legend'],
          'Disconnected',
          '#ff0000',
          'Zero demand',
          '#f0ad4e',
          'Building',
          '#000000',
          '#ff0000'
        ],
      'line-opacity':
        ['case',
          [
            'boolean',
            ['feature-state', 'm_dragin'],
            false
          ],
          0.2,
          [
            'boolean',
            ['feature-state', 'm_hover'],
            false
          ],
          1,
          0.7
        ],
      'line-width': [
        'interpolate',
        ['exponential', 2],
        ['zoom'],
        1,
        1,
        22,
        400
      ],
    }
  };

  layerConn: mapboxgl.Layer = {
    id: this.typeConn,
    type: 'line',
    source: this.typeConn,
    paint: {
      'line-color': '#000000',
      'line-opacity': 0.7,
      'line-width': 1,
    }
  };

  protected initSource(mapbox: mapboxgl.Map) {
    super.initSource(mapbox);
    mapbox.addSource(this.typeConn, {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: []
      }
    });
  }

  protected initLayer(mapbox: mapboxgl.Map) {
    super.initLayer(mapbox);
    mapbox.addLayer(this.layerConn);
  }

  protected setData(mapbox: mapboxgl.Map, elements: Building[]) {
    super.setData(mapbox, elements);

    const source = mapbox.getSource(this.typeConn) as mapboxgl.GeoJSONSource;
    source.setData({
      type: 'FeatureCollection',
      features: this.buildConnMapper(elements)
    });
  }

  buildConnMapper(elements: Building[]) {
    return elements.filter(b => b.vertex)
      .map(buildingVertexToFeature);
  }

  visible(mapbox: mapboxgl.Map, visible: boolean) {
    super.visible(mapbox, visible);
    const visibility = visible ? 'visible' : 'none';
    mapbox.setLayoutProperty(this.typeConn, 'visibility', visibility);
  }

}
